<template>
  <div class="modal-wrapper miv-modal-wrapper" :class="{ black }" @click.self="closeModal">
    <transition name="modal" appear>
      <div class="modal" :class="classes">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: ["classes", "black", "bypassKeydownEvents"],
  methods: {
    handleKeydown(e) {
      if (this.bypassKeydownEvents) return;

      if (e.key === "Escape") {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit("close");
    },
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style lang="scss">
.miv-modal-wrapper {
  z-index: 1000;

  &.black {
    background-color: #000;
  }

  .modal {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 2px 14px #00000026;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 13px;

    &.full {
      width: 100%;
      padding: 0;
    }

    &.medium {
      width: 640px;
    }

    &.small {
      width: 360px;
    }

    &.transparent {
      background: transparent;
    }

    > header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;

      p {
        font-weight: 700;
        text-align: center;
      }

      .modal__close {
        border-radius: 50%;
        background-color: rgba($color: #a8a8a8, $alpha: 0.2);
        cursor: pointer;
        display: flex;
        padding: 0.5rem;
        transition: var(--transition, all 0.3s);

        svg {
          height: auto;
          width: 15px;
        }

        &:hover {
          background-color: rgba($color: #a8a8a8, $alpha: 0.4);
        }
      }
    }

    > main {
      display: flex;
      flex-direction: column;
      gap: 5px;
      max-height: calc(90vh - 200px);
      overflow: auto;

      &.center {
        align-items: center;
      }

      > .modal__label:not(:first-child),
      > .modal__checkbox-wrapper:not(:first-child) {
        margin-top: 5px;
      }
    }

    > footer {
      display: flex;
      justify-content: space-between;
      gap: var(--gap, 10px);

      .row:last-of-type {
        justify-content: flex-end;
      }
    }

    .modal__label {
      color: #1964ba;
      font-size: 12px;
      font-weight: 700;
      opacity: 0.5;
      line-height: 12px;
      text-transform: uppercase;
      transition: var(--transition, all 0.3s);

      &.invalid {
        color: var(--color-danger, #bf392a);
        opacity: 1;
      }
    }

    .modal__print-label {
      display: none;
    }

    .modal__button:not(.full) {
      padding: 0 1rem;
      width: initial;
    }

    .inventory-log {
      background: #ececec;
      border-radius: 4px;
      padding: 5px 7.5px;

      table {
        td {
          &:first-child {
            padding-right: var(--gap, 10px);
            vertical-align: top;
          }
        }
      }
    }

    hr {
      border: none;
      border-top: 1px solid #e4edf3;
      height: 0;
      margin: 20px 0;
      width: 100%;
    }

    .modal__container {
      background-color: var(--color-input-bg, #fff);
      border: 1px solid var(--color-input-border, #d8d2bd);
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      gap: var(--gap, 10px);
      padding: 8px;

      &.transparent {
        border-color: transparent;
        background-color: transparent;
      }

      &.invalid {
        background-color: var(--color-danger-medium, #f8dcdc);
      }

      .texts {
        color: #000;

        &.danger {
          color: var(--color-danger, #bf392a);
        }

        p {
          &:first-child {
            font-size: 13px;
            font-weight: 500;
          }

          &:last-child {
            font-size: 13px;
            opacity: 0.5;
          }
        }
      }
    }
  }

  .modal-enter-active,
  .modal-leave-active {
    transition: var(--transition, all 0.3s);
    transition-delay: 0.1s;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;
    transform: translateY(-20px);
  }
}

@media screen and (max-width: 1000px) {
  .miv-modal-wrapper {
    .modal {
      max-width: calc(100% - 20px);
      width: calc(100% - 20px);

      &.medium,
      &.small {
        max-width: calc(100% - 20px);
        width: calc(100% - 20px);
      }

      > main {
        max-height: calc(var(--vh, 1vh) * 60);
      }

      .row--desktop {
        flex-direction: column;
        gap: 5px;
      }

      > footer {
        &.footer--wrap {
          flex-wrap: wrap;
        }

        &.center {
          justify-content: center;
        }
      }
    }
  }
}

@media print {
  .miv-modal-wrapper {
    .modal {
      > main {
        overflow: initial;
        max-height: initial;
      }

      .modal__label {
        color: #000;
      }

      .modal__print-label {
        display: inline;
        color: #000;
        font-size: 13px;
        font-weight: 700;
        margin-right: var(--gap, 10px);
        white-space: nowrap;

        strong {
          display: block;
        }
      }
    }
  }
}
</style>
